import React from 'react';
import { Tag } from '@fourthwall/components';
import * as S from './StockContent.styled';
export const StockCellContent = ({ type, quantity, showFullLabel = false, }) => {
    const getStockLabel = () => {
        if (type === 'UNLIMITED') {
            return `Unlimited${showFullLabel ? ' stock' : ''}`;
        }
        if (type === 'MIXED') {
            return `Mixed${showFullLabel ? ' stock' : ''}`;
        }
        if (type === 'SOLD_OUT') {
            return `Sold out${showFullLabel ? ' stock' : ''}`;
        }
        if (type === 'LIMITED' && quantity === 0) {
            return showFullLabel ? ('Out of stock') : (React.createElement(S.TagContainer, null,
                React.createElement(Tag, { label: "Out", appearance: "critical" })));
        }
        return `${quantity}${showFullLabel ? ' in stock' : ''}`;
    };
    return React.createElement(S.Container, null, getStockLabel());
};
